var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"outreach none-fluid link"},[_c('banner',[_vm._v("University Administration Experience")]),_c('div',{staticClass:"mx-auto"},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.content))}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }